import styled from 'styled-components'
import {Link as LinkScroll /*, animateScroll as scroll*/ } from "react-scroll"; //https://www.digitalocean.com/community/tutorials/how-to-implement-smooth-scrolling-in-react-es
import {Link as LinkRouter} from "react-router-dom"
import CloseIcon from '@material-ui/icons/Close';

export const Container = styled.div`
    position: fixed;
    display: grid;
    grid-template-columns: 100%;
    align-items: center;
    justify-items: center;
    text-align: center;
    grid-template-rows: repeat(5, 20vh);
    width: 100vw;
    height: 100vh;
    top: 0;
    right: 0;
    background: black;
    z-index: 10;
    animation: 250ms all ease-in-out;

    // The $ allows us to put JS code inside of the property, and then we put {a function}
    // The function can be written:
    // dollar{({isOpen}) => (
    //    conditional
    // )}
    opacity: ${({isOpen}) => (isOpen ? '100%' : '0%')};
    top: ${({ isOpen }) => (isOpen ? '0%' : '100%')};
`;

export const Anchor = styled(LinkScroll)`
    color: white;
    font-family: 'Fira Sans', sans-serif;
    cursor: pointer;

`;

export const Link = styled(LinkRouter)`
    color: white;
    font-family: 'Fira Sans', sans-serif;
`;


export const Close = styled(CloseIcon)`
color: white;
cursor: pointer;
`;